import { computed, ref } from 'vue'
import useApiRequest from '@core/hooks/useApiRequest'
import DiagnosticsItem from '@diagnostics/models/DiagnosticsItem'
import { fetchDiagnosticsItem } from '@diagnostics/services/diagnostics'
import useEventEmitter from '@core/hooks/useEventEmitter'

interface Emits {
  'request-fetch-diagnostics-item-success': never
  'request-fetch-diagnostics-item-error': string[]
}

const DiagnosticsItemController = () => {
  const { $on, $off, $emit } = useEventEmitter<Emits>()

  const data = ref<DiagnosticsItem | null>(null)

  const itemRequest = useApiRequest(fetchDiagnosticsItem)

  itemRequest.$on('success', responseData => {
    data.value = new DiagnosticsItem(responseData)
    $emit('request-fetch-diagnostics-item-success')
  })
  itemRequest.$on('error', responseError => {
    const errors = Array.isArray(responseError) ? responseError : [responseError.detail]
    $emit('request-fetch-diagnostics-item-error', errors)
  })

  const request = (id: number) => {
    itemRequest.request(id)
  }

  return {
    data: computed(() => data.value),
    isLoading: computed(() => itemRequest.isLoading),
    request,
    $on,
    $off
  }
}

export default DiagnosticsItemController
